import { React, useState } from "react";
import { Calendar } from "react-date-range";
 import { useEffect } from "react";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; //  css file
import format from "date-fns/format";
import { useTranslation } from "react-i18next";
import CheckBoxs from "./FiltterCompo/CheckBoxs";
import { t } from "i18next";




function Filter({ FilterOpen, setFilterOpen,FiltredData,setFiltredData , Receiptes, theme }) {
  const [PeriodOpen, setPeriodOpen] = useState(false);
  const [StatusOpen, setStatusOpen] = useState(false);
  const {t , i18n} = useTranslation() 
  const [Calendar1Open, setCalendar1Open] = useState(false);
  const [Calendar2Open, setCalendar2Open] = useState(false);
  const [date, setDate] = useState({
    StartDate: null,
    EndDate: null,
  });
  const [Period, setPeriod] = useState("All Date");
  const [Status, setStatus] = useState('All');

  const [timeOrder, setTimeOrder] = useState(null);
  const [alphabeticalOrder, setAlphabeticalOrder] = useState(null);
  const [priceOrder, setPriceOrder] = useState(null);
  const [receiptType, setReceiptType] = useState(null);


 
  var isArabic = i18n.language.startsWith('ar');
 
 
 
  function ClearFilter(){
    setDate({
        StartDate: null,
    EndDate: null,
    })
setPeriod("All Date")
setStatus("All")


setTimeOrder(null)
setAlphabeticalOrder(null)
setPriceOrder(null)
setReceiptType(null)
    
  }
 

  function ApplyFilter(data)  {
    const currentDate = new Date();
    let startDate = new Date();
  
    if (Period === 'Today') {
      startDate.setHours(0, 0, 0, 0);
    } else if (Period === 'Yesterday') {
      startDate.setDate(currentDate.getDate() - 1);
      startDate.setHours(0, 0, 0, 0);
    } else if (Period === 'This week') {
      startDate.setDate(currentDate.getDate() - currentDate.getDay());
      startDate.setHours(0, 0, 0, 0);
    } else if (Period === 'Last week') {
      startDate.setDate(currentDate.getDate() - 7 - currentDate.getDay());
      startDate.setHours(0, 0, 0, 0);
    } else if (Period === 'This month') {
      startDate.setDate(1);
      startDate.setHours(0, 0, 0, 0);
    } else if (Period === 'Last month') {
      startDate.setMonth(currentDate.getMonth() - 1, 1);
      startDate.setHours(0, 0, 0, 0);
    } else if (Period === 'This year') {
      startDate.setMonth(0, 1);
      startDate.setHours(0, 0, 0, 0);
    } else if (Period  === 'Last year') {
      startDate.setFullYear(currentDate.getFullYear() - 1, 0, 1);
      startDate.setHours(0, 0, 0, 0);
    }
  
    let filteredData = data;
  
    // Apply date filter if Period is not 'All Date'
    if (Period !== 'All Date') {
      filteredData = filteredData?.filter((item) => {
        const itemDate = new Date(item.created_at);
        return itemDate >= startDate;
      });
    }
  
    // Apply additional filters based on StartDate and EndDate
    if (date.StartDate && date.EndDate) {
      const fromTimestamp = date.StartDate.getTime();
      const toTimestamp = date.EndDate.getTime();
  
      filteredData = filteredData?.filter((receipt) => {
        const createdAt = new Date(receipt.created_at).getTime();
        return createdAt >= fromTimestamp && createdAt <= toTimestamp;
      });
    }
  
    // Apply status filter
    if (Status !== 'All') {
      if (Status === 'Paid') {
        filteredData = filteredData?.filter((i) => i?.json?.credit === 0);
      } else if (Status === 'Unpaid') {
        filteredData = filteredData?.filter((i) => i?.json?.credit === i?.json?.total);
      } else if (Status === 'Partially Paid') {
        filteredData = filteredData?.filter((i) => i?.json?.credit < i?.json?.total && i?.json?.credit !== 0);
      } else {
        filteredData = filteredData?.filter((i) => i?.json?.total === 0);
      }
    }
  
  
    // Apply Date OldtoNew & NewtoOld Sort
   filteredData = filteredData?.sort((a, b) => {
    const dateA = new Date(a.created_at);
    const dateB = new Date(b.created_at);

    if (timeOrder === 'newToOld') {
      // Sort by 'created_at' from new to old
      return dateB - dateA;
    } else if (timeOrder === 'oldToNew') {
      // Sort by 'created_at' from old to new
      return dateA - dateB;
    } else {
      // Default to new to old if sortOrder is not specified or invalid
      return dateB - dateA;
    }
  });
// Apply AtoZ & ZtoA Sort 
    filteredData = filteredData?.sort((a, b) => {
  const nameA = a.json?.products[0]?.name.toLowerCase(); // Assuming name is within products array
  const nameB = b.json?.products[0]?.name.toLowerCase();

  if (alphabeticalOrder === 'aToZ') {
    // Sort alphabetically from A to Z
    return nameA?.localeCompare(nameB);
  } else if (alphabeticalOrder === 'zToA') {
    // Sort alphabetically from Z to A
    return nameB?.localeCompare(nameA);
  }  
});


// Apply Pirce Sort 
 
  filteredData = filteredData?.sort((a, b) => {
    const totalA = a.json?.total;
    const totalB = b.json?.total;

    if (priceOrder === 'highToLow') {
      // Sort by total from high to low
      return totalB - totalA;
    } else if(priceOrder === 'lowTohigh') {
      // Sort by total from low to high
      return totalA - totalB;
    } 
  });

// Aplly filterr of digital and phy
 if(receiptType){
   filteredData = filteredData?.filter((receipt) => receipt.file_type === receiptType && receiptType);
 }


 


    setFiltredData(filteredData);
  }

const StatusArray = [
  { text: t('filter.all'), value: "All" },
  { text: t('receipts.paid'), value: "Paid" },
  { text:t('receipts.Unpaid'), value: "Unpaid" },
  { text:t('receipts.Ppaid'), value: "Partially Paid" },
  { text: t('receipts.refunded'), value: "Refunded" }
];
 

  const PeriodArray = [
    {text:t('filter.AllDate') , value:"All Date" },
    {text:t("filter.Today") , value:"Today" },
    {text:t("filter.Yesterday") , value:"Yesterday" },
    {text:t("filter.Thisweek") , value:"This week" },
    {text:t("filter.Lastweek") , value:"Last week" },
    {text:t("filter.Thismonth") , value:"This month" },
    {text:t("filter.Lastmonth") , value:"Last month" },
    {text:t("filter.Thisyear") , value:"This year" },
    {text:t("filter.Lastyear") , value:"Last year" },
  ];
  
  
  return (
    <div
      className={`  top-0 h-full flex fixed duration-150 right-0 ${
        FilterOpen ? "z-50 opacity-100" : " -z-10   opacity-0 "
      }   w-full   `}
    >
      <div
        onClick={() => setFilterOpen(false)}
        className={`absolute z-10 top-0 right-0 w-full h-full bg-black  ${
          FilterOpen ? " bg-opacity-25" : "  bg-opacity-0 "
        }   duration-400 `}
      ></div>
      <div
        className={`   ${theme ? " bg-white" : ' bg-[#212121]' } ${
          FilterOpen ? "right-0" : " right-[-100%] "
        }  duration-300  z-20 absolute        top-0 right-0 w-[82%]  py-14 h-full`}
      >
        <div className= {`   flex   ${isArabic ?"  flex-row-reverse":" flex-row" } justify-between items-center absolute top-0 right-0 w-full px-[1.3rem] h-[4rem]    flex-grow  ${theme ? " bg-white" : ' bg-[#212121]' }`}  >
          <h1 className={` w-full text-[1.4rem] font-[700] `}  >{t('filter.title')}</h1>
          <span onClick={() => setFilterOpen(false)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="17"
              height="18"
              viewBox="0 0 17 18"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M4.09339 1.2157C7.18725 0.872762 10.3095 0.872762 13.4034 1.2157C15.1164 1.4077 16.4984 2.7567 16.6994 4.4757C17.0663 7.61334 17.0663 10.7831 16.6994 13.9207C16.5977 14.756 16.2168 15.5324 15.6186 16.1241C15.0203 16.7159 14.2397 17.0882 13.4034 17.1807C10.3096 17.5247 7.18719 17.5247 4.09339 17.1807C3.25705 17.0882 2.47647 16.7159 1.87822 16.1241C1.27996 15.5324 0.899106 14.756 0.797394 13.9207C0.430491 10.7834 0.430491 7.61401 0.797394 4.4767C0.899062 3.64157 1.27977 2.86524 1.87783 2.27354C2.47588 1.68184 3.25623 1.30944 4.09239 1.2167L4.09339 1.2157ZM5.21839 5.6687C5.35902 5.52825 5.54964 5.44936 5.74839 5.44936C5.94714 5.44936 6.13777 5.52825 6.27839 5.6687L8.74839 8.1387L11.2184 5.6687C11.2871 5.59501 11.3699 5.53591 11.4619 5.49492C11.5539 5.45393 11.6532 5.43188 11.7539 5.43011C11.8546 5.42833 11.9546 5.44685 12.048 5.48458C12.1414 5.5223 12.2262 5.57844 12.2974 5.64966C12.3687 5.72088 12.4248 5.80571 12.4625 5.8991C12.5002 5.99249 12.5188 6.09252 12.517 6.19322C12.5152 6.29392 12.4932 6.39324 12.4522 6.48524C12.4112 6.57724 12.3521 6.66004 12.2784 6.7287L9.80839 9.1987L12.2784 11.6687C12.4109 11.8109 12.483 11.9989 12.4796 12.1932C12.4761 12.3875 12.3974 12.5729 12.26 12.7103C12.1226 12.8477 11.9372 12.9264 11.7429 12.9299C11.5486 12.9333 11.3606 12.8612 11.2184 12.7287L8.74839 10.2587L6.27839 12.7287C6.20973 12.8024 6.12693 12.8615 6.03493 12.9025C5.94293 12.9435 5.84362 12.9655 5.74292 12.9673C5.64221 12.9691 5.54218 12.9505 5.4488 12.9128C5.35541 12.8751 5.27058 12.819 5.19936 12.7477C5.12814 12.6765 5.07199 12.5917 5.03427 12.4983C4.99655 12.4049 4.97803 12.3049 4.9798 12.2042C4.98158 12.1035 5.00362 12.0042 5.04461 11.9122C5.0856 11.8202 5.14471 11.7374 5.21839 11.6687L7.68839 9.1987L5.21839 6.7287C5.07794 6.58807 4.99905 6.39745 4.99905 6.1987C4.99905 5.99995 5.07794 5.80932 5.21839 5.6687Z"
                fill="#E3E3E7"
              />
            </svg>
          </span>
        </div>
        <div
          className={` w-full flex flex-col gap-3 px-[1.3rem] ${
            Calendar2Open || Calendar1Open ? "" : "overflow-auto"
          }  flex-grow h-full pb-10`}
        >
          <h1 className=" text-[.8] font-medium pt-[1rem] ">{t('filter.Ptitle')}</h1>

          <div
            onClick={() => setPeriodOpen(!PeriodOpen)}
            className= {`  ${theme ? "  bg-opacity-100" : 'bg-opacity-10 ' }   relative items-center flex   ${isArabic ?"  flex-row-reverse":" flex-row" }   justify-between  px-[.7rem] w-full  py-4  h-[5rem]   bg-[#F8F8F8] rounded-[.27rem] `} 
          >
            <span className=" w-full text-[.9rem] text-sec">{ PeriodArray.find((i)=> i.value == Period ).text }</span>
            <span onClick={() => setPeriodOpen(!PeriodOpen)}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="6"
                viewBox="0 0 10 6"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M5.98995 5.71443C5.81267 5.8915 5.57235 5.99095 5.32179 5.99095C5.07123 5.99095 4.83091 5.8915 4.65363 5.71443L1.08716 2.14922C0.909872 1.97185 0.810305 1.73131 0.810364 1.48052C0.810423 1.22974 0.910104 0.989247 1.08748 0.811956C1.26485 0.634665 1.50539 0.535097 1.75618 0.535156C2.00696 0.535215 2.24746 0.634897 2.42475 0.812271L5.32179 3.70932L8.21884 0.812271C8.39708 0.639953 8.63588 0.544537 8.88379 0.546573C9.1317 0.54861 9.3689 0.647936 9.54428 0.82316C9.71967 0.998383 9.81922 1.23548 9.82149 1.48339C9.82376 1.7313 9.72857 1.97019 9.55642 2.14859L5.99058 5.71506L5.98995 5.71443Z"
                  fill="#06C671"
                />
              </svg>
            </span>

            <div
              className={` duration-150   z-10 flex flex-col  top-16 right-0 rounded w-full absolute   ${
                PeriodOpen ? "h-[22.7rem]" : " h-0"
              }  ${!theme  ?' bg-[#1C1C1C] ' :'bg-[#F9F9FF]' }  shadow overflow-hidden `}
            >
              {PeriodArray.map((i) => (
                <div className=" flex flex-col">
                  <span
                    onClick={() => setPeriod(i.value)}
                    className= {`  ${Period == i.value ? ' text-main':'' }    p-2   `}
                  >
                    {" "}
                    {i.text}{" "}
                  </span>
                  <span className={` w-full h-[1px]  ${!theme  ?' bg-[#1C1C1C] bg-[#f2f2f22f]  ' :' bg-[#e9e7e7] ' }  `} ></span>
                </div>
              ))}
            </div>
          </div>

          <div className=" flex    justify-between w-full pt-4 items-center gap-[.6rem]  ">
            <span
              className={`  relative text-[.9rem] flex flex-col items-center   gap-1  ${
                Calendar2Open ? " border-main text-main" : "text-sec"
              } border-solid border-[1px]  rounded   px-1 py-[.7rem] h-[5rem] w-full `}
            >
              <div
                onClick={() => setCalendar2Open(!Calendar2Open)}
                className=" w-full h-full flex flex-col  items-center gap-2"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  viewBox="0 0 17 19"
                  fill="none"
                >
                  <path
                    d="M15.1328 1.73471H13.0745V1.04863C13.0745 0.866668 13.0023 0.692161 12.8736 0.563496C12.7449 0.434832 12.5704 0.362549 12.3885 0.362549C12.2065 0.362549 12.032 0.434832 11.9033 0.563496C11.7747 0.692161 11.7024 0.866668 11.7024 1.04863V1.73471H4.84161V1.04863C4.84161 0.866668 4.76933 0.692161 4.64066 0.563496C4.512 0.434832 4.33749 0.362549 4.15553 0.362549C3.97357 0.362549 3.79907 0.434832 3.6704 0.563496C3.54174 0.692161 3.46945 0.866668 3.46945 1.04863V1.73471H1.41122C1.0473 1.73471 0.698287 1.87927 0.440958 2.1366C0.183629 2.39393 0.0390625 2.74294 0.0390625 3.10686V16.8284C0.0390625 17.1923 0.183629 17.5414 0.440958 17.7987C0.698287 18.056 1.0473 18.2006 1.41122 18.2006H15.1328C15.4967 18.2006 15.8457 18.056 16.103 17.7987C16.3604 17.5414 16.5049 17.1923 16.5049 16.8284V3.10686C16.5049 2.74294 16.3604 2.39393 16.103 2.1366C15.8457 1.87927 15.4967 1.73471 15.1328 1.73471ZM3.46945 3.10686V3.79294C3.46945 3.9749 3.54174 4.14941 3.6704 4.27807C3.79907 4.40673 3.97357 4.47902 4.15553 4.47902C4.33749 4.47902 4.512 4.40673 4.64066 4.27807C4.76933 4.14941 4.84161 3.9749 4.84161 3.79294V3.10686H11.7024V3.79294C11.7024 3.9749 11.7747 4.14941 11.9033 4.27807C12.032 4.40673 12.2065 4.47902 12.3885 4.47902C12.5704 4.47902 12.7449 4.40673 12.8736 4.27807C13.0023 4.14941 13.0745 3.9749 13.0745 3.79294V3.10686H15.1328V5.85117H1.41122V3.10686H3.46945ZM15.1328 16.8284H1.41122V7.22333H15.1328V16.8284ZM6.89985 9.28157V14.7702C6.89985 14.9522 6.82756 15.1267 6.6989 15.2553C6.57023 15.384 6.39573 15.4563 6.21377 15.4563C6.03181 15.4563 5.8573 15.384 5.72864 15.2553C5.59997 15.1267 5.52769 14.9522 5.52769 14.7702V10.3913L5.14863 10.5817C4.98578 10.6631 4.79725 10.6765 4.62451 10.6189C4.45178 10.5614 4.309 10.4375 4.22757 10.2747C4.14614 10.1118 4.13274 9.92328 4.19032 9.75055C4.2479 9.57782 4.37174 9.43503 4.53459 9.3536L5.90675 8.66753C6.01138 8.61516 6.12767 8.59044 6.24456 8.59569C6.36145 8.60094 6.47506 8.636 6.57458 8.69753C6.6741 8.75907 6.75622 8.84503 6.81316 8.94725C6.87009 9.04947 6.89993 9.16456 6.89985 9.28157ZM11.9734 11.893L10.3302 14.0841H11.7024C11.8844 14.0841 12.0589 14.1564 12.1875 14.2851C12.3162 14.4137 12.3885 14.5882 12.3885 14.7702C12.3885 14.9522 12.3162 15.1267 12.1875 15.2553C12.0589 15.384 11.8844 15.4563 11.7024 15.4563H8.95808C8.83067 15.4563 8.70577 15.4208 8.59739 15.3538C8.489 15.2868 8.40141 15.191 8.34443 15.077C8.28745 14.9631 8.26333 14.8355 8.27477 14.7086C8.28622 14.5817 8.33277 14.4605 8.40922 14.3585L10.8774 11.0679C10.9335 10.9932 10.9738 10.9078 10.9957 10.8169C11.0177 10.7261 11.0208 10.6317 11.005 10.5395C10.9891 10.4474 10.9546 10.3595 10.9036 10.2812C10.8525 10.2029 10.786 10.1359 10.7081 10.0842C10.6302 10.0325 10.5426 9.99729 10.4506 9.9807C10.3586 9.96411 10.2642 9.9665 10.1732 9.98771C10.0821 10.0089 9.99637 10.0485 9.92118 10.104C9.846 10.1596 9.78295 10.2299 9.73592 10.3107C9.6922 10.3912 9.6328 10.4621 9.56122 10.5193C9.48964 10.5765 9.40733 10.6188 9.31915 10.6436C9.23097 10.6685 9.1387 10.6754 9.04779 10.6641C8.95688 10.6527 8.86917 10.6232 8.78984 10.5774C8.71051 10.5316 8.64115 10.4703 8.58587 10.3972C8.5306 10.3242 8.49051 10.2408 8.46798 10.152C8.44546 10.0632 8.44094 9.97076 8.45471 9.88018C8.46848 9.78961 8.50025 9.7027 8.54815 9.6246C8.77478 9.23242 9.12446 8.92594 9.54297 8.75268C9.96149 8.57943 10.4255 8.54907 10.863 8.66632C11.3005 8.78356 11.6872 9.04187 11.963 9.40118C12.2388 9.7605 12.3883 10.2008 12.3885 10.6537C12.3899 11.1012 12.2441 11.5367 11.9734 11.893Z"
                    fill="#06C671"
                    fill-opacity="0.81"
                  />
                </svg>
                <h1>
                  {" "}
                  {date?.StartDate == null
                    ? t("filter.startD")
                    : format(date?.StartDate, "MM/dd/yyyy")}{" "}
                </h1>
              </div>
              {Calendar2Open && (
                <span className=" w-full h-full    ">
                  <span
                    onClick={() => setCalendar2Open(!Calendar2Open)}
                    className=" w-full fixed top-0   z-50 right-0 h-full "
                  ></span>
                  <span className=" z-50 absolute top-16 shadow-lg    -left-10  ">
                    <Calendar 
                   
                      onChange={(selectedDate) =>
                        setDate({
                          ...date,
                          StartDate: selectedDate,
                        })
                      }
                      color="#06C671"
                      rangeColors={"#06C671"}
                      date={date.StartDate}
                    />
                  </span>
                </span>
              )}
            </span>

            <div
              className={` relative text-[.9rem] flex flex-col items-center   ${
                Calendar1Open ? " border-main text-main" : "text-sec"
              } gap-1 border-solid border-[1px]  rounded    px-1 py-[.7rem] h-[5rem] w-full`}
            >
              <div
                onClick={() => setCalendar1Open(!Calendar1Open)}
                className=" w-full h-full flex flex-col  items-center gap-2"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  viewBox="0 0 17 19"
                  fill="none"
                >
                  <path
                    d="M15.1328 1.73471H13.0745V1.04863C13.0745 0.866668 13.0023 0.692161 12.8736 0.563496C12.7449 0.434832 12.5704 0.362549 12.3885 0.362549C12.2065 0.362549 12.032 0.434832 11.9033 0.563496C11.7747 0.692161 11.7024 0.866668 11.7024 1.04863V1.73471H4.84161V1.04863C4.84161 0.866668 4.76933 0.692161 4.64066 0.563496C4.512 0.434832 4.33749 0.362549 4.15553 0.362549C3.97357 0.362549 3.79907 0.434832 3.6704 0.563496C3.54174 0.692161 3.46945 0.866668 3.46945 1.04863V1.73471H1.41122C1.0473 1.73471 0.698287 1.87927 0.440958 2.1366C0.183629 2.39393 0.0390625 2.74294 0.0390625 3.10686V16.8284C0.0390625 17.1923 0.183629 17.5414 0.440958 17.7987C0.698287 18.056 1.0473 18.2006 1.41122 18.2006H15.1328C15.4967 18.2006 15.8457 18.056 16.103 17.7987C16.3604 17.5414 16.5049 17.1923 16.5049 16.8284V3.10686C16.5049 2.74294 16.3604 2.39393 16.103 2.1366C15.8457 1.87927 15.4967 1.73471 15.1328 1.73471ZM3.46945 3.10686V3.79294C3.46945 3.9749 3.54174 4.14941 3.6704 4.27807C3.79907 4.40673 3.97357 4.47902 4.15553 4.47902C4.33749 4.47902 4.512 4.40673 4.64066 4.27807C4.76933 4.14941 4.84161 3.9749 4.84161 3.79294V3.10686H11.7024V3.79294C11.7024 3.9749 11.7747 4.14941 11.9033 4.27807C12.032 4.40673 12.2065 4.47902 12.3885 4.47902C12.5704 4.47902 12.7449 4.40673 12.8736 4.27807C13.0023 4.14941 13.0745 3.9749 13.0745 3.79294V3.10686H15.1328V5.85117H1.41122V3.10686H3.46945ZM15.1328 16.8284H1.41122V7.22333H15.1328V16.8284ZM6.89985 9.28157V14.7702C6.89985 14.9522 6.82756 15.1267 6.6989 15.2553C6.57023 15.384 6.39573 15.4563 6.21377 15.4563C6.03181 15.4563 5.8573 15.384 5.72864 15.2553C5.59997 15.1267 5.52769 14.9522 5.52769 14.7702V10.3913L5.14863 10.5817C4.98578 10.6631 4.79725 10.6765 4.62451 10.6189C4.45178 10.5614 4.309 10.4375 4.22757 10.2747C4.14614 10.1118 4.13274 9.92328 4.19032 9.75055C4.2479 9.57782 4.37174 9.43503 4.53459 9.3536L5.90675 8.66753C6.01138 8.61516 6.12767 8.59044 6.24456 8.59569C6.36145 8.60094 6.47506 8.636 6.57458 8.69753C6.6741 8.75907 6.75622 8.84503 6.81316 8.94725C6.87009 9.04947 6.89993 9.16456 6.89985 9.28157ZM11.9734 11.893L10.3302 14.0841H11.7024C11.8844 14.0841 12.0589 14.1564 12.1875 14.2851C12.3162 14.4137 12.3885 14.5882 12.3885 14.7702C12.3885 14.9522 12.3162 15.1267 12.1875 15.2553C12.0589 15.384 11.8844 15.4563 11.7024 15.4563H8.95808C8.83067 15.4563 8.70577 15.4208 8.59739 15.3538C8.489 15.2868 8.40141 15.191 8.34443 15.077C8.28745 14.9631 8.26333 14.8355 8.27477 14.7086C8.28622 14.5817 8.33277 14.4605 8.40922 14.3585L10.8774 11.0679C10.9335 10.9932 10.9738 10.9078 10.9957 10.8169C11.0177 10.7261 11.0208 10.6317 11.005 10.5395C10.9891 10.4474 10.9546 10.3595 10.9036 10.2812C10.8525 10.2029 10.786 10.1359 10.7081 10.0842C10.6302 10.0325 10.5426 9.99729 10.4506 9.9807C10.3586 9.96411 10.2642 9.9665 10.1732 9.98771C10.0821 10.0089 9.99637 10.0485 9.92118 10.104C9.846 10.1596 9.78295 10.2299 9.73592 10.3107C9.6922 10.3912 9.6328 10.4621 9.56122 10.5193C9.48964 10.5765 9.40733 10.6188 9.31915 10.6436C9.23097 10.6685 9.1387 10.6754 9.04779 10.6641C8.95688 10.6527 8.86917 10.6232 8.78984 10.5774C8.71051 10.5316 8.64115 10.4703 8.58587 10.3972C8.5306 10.3242 8.49051 10.2408 8.46798 10.152C8.44546 10.0632 8.44094 9.97076 8.45471 9.88018C8.46848 9.78961 8.50025 9.7027 8.54815 9.6246C8.77478 9.23242 9.12446 8.92594 9.54297 8.75268C9.96149 8.57943 10.4255 8.54907 10.863 8.66632C11.3005 8.78356 11.6872 9.04187 11.963 9.40118C12.2388 9.7605 12.3883 10.2008 12.3885 10.6537C12.3899 11.1012 12.2441 11.5367 11.9734 11.893Z"
                    fill="#06C671"
                    fill-opacity="0.81"
                  />
                </svg>
                <h1>
                  {date?.EndDate == null
                    ? t("filter.endD")
                    : format(date?.EndDate, "MM/dd/yyyy")}
                </h1>
              </div>

              {Calendar1Open && (
                <span className=" w-full h-full    ">
                  <span
                    onClick={() => setCalendar1Open(!Calendar1Open)}
                    className=" w-full fixed top-0   z-50 right-0 h-full "
                  ></span>
                  <span className=" z-50 absolute top-16 shadow-lg  right-0  ">
                    <Calendar
                      onChange={(selectedDate) =>
                        setDate({
                          ...date,
                          EndDate: selectedDate,
                        })
                      }
                      minDate={date?.StartDate}
                      color="#06C671"
                      rangeColors={"#06C671"}
                      date={date.EndDate}
                    />
                  </span>
                </span>
              )}
            </div>
          </div>
          <h1 className=" text-[.8] font-medium pt-[1rem] "> {t('filter.Status')} </h1>

          <div
            onClick={() => setStatusOpen(!StatusOpen)}
            className={`  ${theme ? "  bg-opacity-100" : 'bg-opacity-10 ' } ${isArabic ?"  flex-row-reverse":" flex-row" }   relative items-center flex   justify-between px-[.7rem] w-full  py-4  h-[5rem] mt-[1rem] bg-[#F8F8F8] rounded-[.27rem] `}
          >
            <span className=" w-full text-[.9rem] text-sec">{ StatusArray.find((i)=> i.value == Status ).text }</span>
            <span onClick={() => setStatusOpen(!StatusOpen)}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="6"
                viewBox="0 0 10 6"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M5.98995 5.71443C5.81267 5.8915 5.57235 5.99095 5.32179 5.99095C5.07123 5.99095 4.83091 5.8915 4.65363 5.71443L1.08716 2.14922C0.909872 1.97185 0.810305 1.73131 0.810364 1.48052C0.810423 1.22974 0.910104 0.989247 1.08748 0.811956C1.26485 0.634665 1.50539 0.535097 1.75618 0.535156C2.00696 0.535215 2.24746 0.634897 2.42475 0.812271L5.32179 3.70932L8.21884 0.812271C8.39708 0.639953 8.63588 0.544537 8.88379 0.546573C9.1317 0.54861 9.3689 0.647936 9.54428 0.82316C9.71967 0.998383 9.81922 1.23548 9.82149 1.48339C9.82376 1.7313 9.72857 1.97019 9.55642 2.14859L5.99058 5.71506L5.98995 5.71443Z"
                  fill="#06C671"
                />
              </svg>
            </span>

            <div
              className={` duration-150   z-10  flex flex-col  top-16 right-0 rounded w-full absolute   ${
                StatusOpen ? "h-[12.5rem]" : " h-0"
              }  ${theme ? " bg-white" : ' bg-[#212121]' }  shadow overflow-hidden `}
            >
              {StatusArray.map((i) => (
        <div key={i.index} className="flex flex-col">
          <span
            onClick={() =>
              setStatus(i.value)
            }
            className= {`  ${Period == i.value ? ' text-main':'' }    p-2   `}
          >
            {i.text}
          </span>
          <span className={` w-full h-[1px]  ${!theme  ?' bg-[#1C1C1C] bg-[#f2f2f22f]  ' :' bg-[#e9e7e7] ' }  `} ></span>
        </div>
      ))}
            </div>
          </div>
       






          <CheckBoxs
            timeOrder={timeOrder} 
             setTimeOrder={setTimeOrder}
            alphabeticalOrder={alphabeticalOrder}
            setAlphabeticalOrder={setAlphabeticalOrder}
            priceOrder={priceOrder}
            setPriceOrder={setPriceOrder}
            receiptType={receiptType}
            setReceiptType={setReceiptType}
            />

          <div className={` absolute   gap-3 bottom-0 right-0 w-full justify-between items-center flex  ${isArabic ? ' flex-row-reverse':' flex-row'  } px-5 h-[4rem] border-solid border-t-[1px]  ${theme ? " bg-white" : ' bg-[#212121]' } `}>
            <button  onClick={ClearFilter}  className=" w-full flex items-center gap-2 justify-center text-sec bg-transparent ">
             {t('filter.clear')}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="10"
                viewBox="0 0 8 8"
                fill="none"
              >
                <path
                  d="M0.875 6.86121L3.99597 3.74023L7.11694 6.86121M7.11694 0.619263L3.99538 3.74023L0.875 0.619263"
                  stroke="#A4A4A4"
                  stroke-width="0.892897"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>{" "}
            </button>

            <button onClick={ ()=> { ApplyFilter(Receiptes) ;setFilterOpen(!FilterOpen) } } className=" flex items-center gap-1   justify-center border-solid border-main border-[2px] text-main  w-full rounded-full  font-[600] py-[.7rem] bg-transparent ">
              {t('filter.title')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Filter;
